import { useMemo } from 'react';
import linkifyStr from 'linkify-string';
import parse from 'html-react-parser';

const useLinkifiedLabel = (label: string) => {
  return useMemo(() => {
    if (!label || label === '') {
      return '';
    }
    const newLabel = linkifyStr(label, {
      target: '_blank',
    });
    if (newLabel !== label) {
      return <span>{parse(label)}</span>;
    }
    return label;
  }, [label]);
};

export default useLinkifiedLabel;
